import React, { Fragment } from 'react';
import Tabs from './data/tabs';
import servicesData from './data/spa-services';

import GoFetch from '~/js/modules/fetchling';

import ClickOut from '~/js/components/global/ClickOut';
import Spinner from '~/js/components/general/Spinner';
import Select from '~/js/components/general/Select';
// import QuickQuote from '~/js/components/global/QuickQuote';

import EventItem from '../redlane-spa/EventItem';
import ServiceItem from '../redlane-spa/ServiceItem';
import BookPopover from '../redlane-spa/BookPopover';

const fetch = new GoFetch();

export default class SpaWeddings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      eventsData: null,
      isLoading: true,
      priceChecked: {},
      tabChecked: {
        [Tabs[3].id]: Tabs[3]
      },
    };
  }

  componentDidMount() {
    // this.getData();
  }

  getData = () => {
    const data = {
      subgroupId: 41
    };

    fetch.post('/events/fetchSpas/', null, data)

      .then((response) => {
        const { events } = response.data;
        const eventsObj = {};

        for (const item of events) {
          item.rates = item.rates.map((el) => {
            el.duration = item.duration;

            return el;
          });

          if (eventsObj[item.eventName]) {
            eventsObj[item.eventName].rates.push(...item.rates);
          } else {
            eventsObj[item.eventName] = item;
          }
        }

        this.setState(
          { eventsData: Object.values(eventsObj), isLoading: false }
        );
      });
  }

  priceChangeHandler = (item, multiselect, index) => {
    this.setState((prevState) => {
      const priceChecked = { ...prevState.priceChecked };

      priceChecked[index] = { [item.id]: item };

      return { priceChecked };
    });
  }

  tabsHandler = (el) => {
    this.setState({ tabChecked: { [el.id]: el } });
  }

  render() {
    const { tabChecked, priceChecked, isLoading, eventsData, bookNowPopover } = this.state;
    const selectedTab = Object.values(tabChecked)[0];

    let filtredServicesData = servicesData;
    let servicesList = <Spinner />;
    let eventsList;

    if (selectedTab.param !== 'all') {
      filtredServicesData = servicesData.filter((el) => el.type === selectedTab.param);
    }

    let filteredItems = filtredServicesData.length;

    if (!isLoading) {

      filteredItems = filtredServicesData.length + eventsData.length;

      if (eventsData.length && selectedTab.param === 'all' || selectedTab.param === 'bridal') {

        eventsList = eventsData.map((event, index) => {

          const selectedHandler = (item, multiselect) => {
            this.priceChangeHandler(item, multiselect, index);
          };

          const bookNowHandler = (action) => {
            this.setState({ bookNowPopover: action ? index : null });
          };

          const rates = event.rates.map((el, id) => ({
            id: id,
            rate: el.rate,
            label: `${el.duration || 0} Minutes - $${el.rate || 0}`
          }));


          const props = {
            key: index,
            images: event.mainImages,
            name: event.eventName,
            rates: rates,
            description: event.descriptionWithoutHtml,
            checked: priceChecked[index] || {},
            onSelected: selectedHandler,
            onBookNow: bookNowHandler
          };

          if (bookNowPopover === index) {
            if (priceChecked.hasOwnProperty(bookNowPopover)) {
              props.popover = (
                <ClickOut callback={() => this.setState({ bookNowPopover: null })}>
                  <BookPopover closeup={() => bookNowHandler(false)}>
                    <div>QuickQuote Component</div>
                  </BookPopover>
                </ClickOut>
              );
            } else {
              props.validationPopover = (
                <ClickOut callback={() => this.setState({ bookNowPopover: null })}>
                  <BookPopover closeup={() => bookNowHandler(false)}>
                    <Fragment>
                      <h6 className="title">Select Option First</h6>
                      <p className="validation-text">Please select the duration of the treatment you would like to book.</p>
                    </Fragment>
                  </BookPopover>
                </ClickOut>
              );
            }
          }

          return <EventItem { ...props } />;
        });
      }
    }

    servicesList = (
      <Fragment>
        {eventsList}

        {filtredServicesData.map((service, index) => {
          return (
            <ServiceItem
              key={index}
              image={service.image}
              title={service.title}
              subTitle={service.subTitle}
              description={service.description}
              list={service.list}
              price={service.price} />
          );
        })}
      </Fragment>
    );

    return (
      <Fragment>
        <div className="tabs-wrap">
          <div className="container">
            <ul className="tabs">
              {Tabs.map((el, index) => {
                let className;

                if (tabChecked[el.id]) { className = 'active'; }

                return (
                  <li
                    key={index}
                    className={className}
                    onClick={() => this.tabsHandler(el)}
                  >
                    <span>{el.label}</span>
                  </li>
                );
              })}
            </ul>

            <Select
              className="tabs-select"
              data={Tabs}
              checked={tabChecked}
              placeholder="View All Treatments"
              onChange={this.tabsHandler} />
          </div>
        </div>

        <div className="container">
          <h5 className="sessions-list-title">{filteredItems} treatments found <span className="resort-name"/></h5>
          <div className="sessions-list">
            {servicesList}
          </div>
        </div>
      </Fragment>
    );
  }
}
